// extracted by mini-css-extract-plugin
export default {"wrapper":"icon-button_wrapper__mPsmT","open":"icon-button_open__9BZF9"};